var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0011 11C15.6952 11 11.3813 15.3138 11.3813 20.6197C11.3813 25.9256 15.6952 30.2395 21.0011 30.2395C21.5156 30.2395 22.0195 30.1972 22.5103 30.1207C21.4549 29.2316 20.7847 27.9018 20.7847 26.4137C20.7847 23.7357 22.9562 21.5643 25.6342 21.5643C27.5048 21.5643 29.1275 22.6249 29.9348 24.179C30.3754 23.0788 30.6182 21.8783 30.6182 20.6224C30.6208 15.3138 26.3043 11 21.0011 11ZM21.9826 20.6593C21.9826 21.2055 21.5393 21.6487 20.9932 21.6487H15.587C15.0409 21.6487 14.5976 21.2055 14.5976 20.6593C14.5976 20.1132 15.0409 19.6699 15.587 19.6699H20.0038V15.2532C20.0038 14.707 20.447 14.2637 20.9932 14.2637C21.5393 14.2637 21.9826 14.707 21.9826 15.2532V20.6593Z",
    fill: "#F8FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0297 29.6248L28.3384 27.9336C28.5917 27.485 28.7368 26.9653 28.7368 26.4138C28.7368 24.7015 27.349 23.311 25.634 23.311C23.9191 23.311 22.5312 24.6989 22.5312 26.4138C22.5312 28.1288 23.9191 29.5166 25.634 29.5166C26.2092 29.5166 26.7448 29.3583 27.2066 29.0839L28.8872 30.7646C29.2012 31.0786 29.7131 31.0786 30.027 30.7646C30.341 30.4506 30.341 29.9388 30.027 29.6248H30.0297Z",
    fill: "#F8FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.ebeff813e981aacc6be111796a2128e9.svg";
export { ForwardRef as ReactComponent };